module.exports = __webpack_public_path__ + "static/media/worksheet-62675.b6b79c21.png";